import { render, staticRenderFns } from "./usercard.vue?vue&type=template&id=7fae88d8&"
import script from "./usercard.vue?vue&type=script&lang=js&"
export * from "./usercard.vue?vue&type=script&lang=js&"
import style0 from "./usercard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports